"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _PEPGuideConfigQuestion = _interopRequireDefault(require("./PEPGuideConfigQuestion"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PEPGuideConfig =
/**
 * Parses the configuration for a PEP guide passed to a PEPComponent from Sitecore.
 * @param {Object} config
 * @constructor
 */
function PEPGuideConfig(config) {
  _classCallCheck(this, PEPGuideConfig);

  /**
   * The list of products IDs configured for the guide.
   * @type {number[]}
   */
  this.productIDs = config.ProductIds || config.productIDs || [];
  /**
   * The list of questions for the guide.
   * @type {PEPGuideConfigQuestion}
   */

  this.questions = function (questionsData) {
    var questions = [];

    if (questionsData && Array.isArray(questionsData)) {
      questionsData.forEach(function (questionData) {
        questions.push(new _PEPGuideConfigQuestion["default"](questionData));
      });
    }

    return questions;
  }(config.Questions || config.questions);
};

var _default = PEPGuideConfig;
exports["default"] = _default;